<template lang="html">
  <v-card class="content-container">
    <v-dialog
      max-width="1000px"
      v-model="previewDialogOpened"
      persistent
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="
        previewDialogOpened = false;
        documentPreviewData = '';
        previewRotation = 0;
      "
    >
      <v-card>
        <v-card-title class="title">
          <v-layout v-if="renameFile" align-center>
            <span class="caption mr-2">New Name:</span>
            <v-text-field
              v-model="newName"
              hide-details
              solo
              class="default-input"
            />
            <span class="subheading">.{{ documentExtension }}</span>
            <v-tooltip bottom class="mx-2">
              <i
                class="material-icons-outlined success--text"
                style="font-size: 20px; cursor: pointer"
                @click="renameItem()"
                slot="activator"
              >
                check
              </i>
              <span>Save</span>
            </v-tooltip>
            <v-tooltip bottom class="ml-2">
              <i
                class="material-icons-outlined error--text"
                style="font-size: 20px; cursor: pointer"
                @click="renameFile = false"
                slot="activator"
              >
                cancel
              </i>
              <span>Cancel</span>
            </v-tooltip>
          </v-layout>
          <v-layout v-else>
            <span>{{ getDocumentName(selectedDocumentLink) }}</span>
            <v-tooltip bottom class="ml-2">
              <i
                class="material-icons-outlined primary--text"
                style="font-size: 20px; cursor: pointer"
                @click="startRenaming()"
                slot="activator"
              >
                edit
              </i>
              <span>Rename</span>
            </v-tooltip>
          </v-layout>

          <v-spacer />
          <v-tooltip bottom class="mr-1">
            <v-btn
              fab
              small
              flat
              class="white primary--text text-capitalize ma-0"
              @click="previewRotation += 90"
              slot="activator"
            >
              <v-icon size="25"> rotate_right </v-icon>
            </v-btn>
            <span>Rotate</span>
          </v-tooltip>
          <v-tooltip
            bottom
            class="mx-1"
            v-if="isAdvisor && !isFirmDocumentsDisabled"
          >
            <v-btn
              fab
              small
              flat
              class="white primary--text text-capitalize ma-0"
              @click="openCopyDialog()"
              slot="activator"
            >
              <i
                class="material-icons-outlined primary--text"
                style="font-size: 25px"
              >
                drive_file_move
              </i>
            </v-btn>
            <span>Move File</span>
          </v-tooltip>
          <v-tooltip bottom class="mx-1">
            <v-btn
              fab
              small
              flat
              class="white primary--text text-capitalize ma-0"
              @click="
                downloadDocumentByLink(
                  documentPreviewData,
                  getDocumentName(selectedDocumentLink),
                )
              "
              slot="activator"
            >
              <i
                class="material-icons-outlined primary--text"
                style="font-size: 25px"
              >
                get_app
              </i>
            </v-btn>
            <span>Download to Computer</span>
          </v-tooltip>
          <v-btn
            fab
            small
            flat
            class="white error--text text-capitalize ma-0"
            @click="
              previewDialogOpened = false;
              documentPreviewData = '';
              previewRotation = 0;
            "
          >
            <v-icon size="25"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="documentPreviewData && previewLoaded">
          <preview-document
            :document-preview-data="documentPreviewData"
            :preview-type="previewType"
            :preview-rotation="previewRotation"
          />
        </v-card-text>
        <v-card-text v-else>
          <v-progress-circular
            indeterminate
            size="50"
            class="primary--text ma-5"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="addLinkDialog = false"
      v-model="addLinkDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="title"> Add Link </v-card-title>
        <v-card-text>
          <v-layout column class="text-xs-left">
            <v-flex class="mb-4">
              <div>Link text</div>
              <v-text-field
                class="default-input body-1"
                solo
                hide-details
                v-model="linkText"
                placeholder="e.g. Click this link"
              />
            </v-flex>
            <v-flex>
              <div>Link URL</div>
              <v-text-field
                class="default-input body-1"
                solo
                hide-details
                v-model="linkURL"
                placeholder="e.g. www.google.com"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer class="hidden-xs-only" />
          <v-btn
            class="default-input primary text-capitalize"
            @click="addLink()"
            :disabled="!linkAddable"
          >
            Add
          </v-btn>
          <v-btn
            outline
            class="default-input error--text text-capitalize"
            @click="addLinkDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      width="600"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="copyItemDialogOpened"
      persistent
      @keydown.esc="copyItemDialogOpened = false"
    >
      <v-card flat>
        <v-card-title class="title"> Specify new location </v-card-title>
        <v-card-text>
          <v-layout align-center class="mb-2 subheading" wrap>
            <div class="mr-1">Save to:</div>
            <div :key="i" v-for="(path, i) in pathsInOrder">
              {{ i !== 0 ? '/' : ''
              }}<span
                class="primary--text font-weight-bold"
                @click="goBackPathForMove(path, i)"
                :style="i !== pathsInOrder.length - 1 ? 'cursor: pointer' : ''"
                >{{ isEmpty(path) ? 'Home' : path }}</span
              >
            </div>
          </v-layout>
          <v-layout align-center>
            <v-select
              class="default-input"
              solo
              item-value="value"
              item-text="label"
              :placeholder="
                isEmpty(foldersInLastPath) ? 'No folders' : 'Choose folder'
              "
              hide-details
              :items="foldersInLastPath"
              :disabled="isEmpty(foldersInLastPath)"
              v-model="lastPathInOrder"
              @change="changePath()"
            />
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="text-capitalize primary"
            @click="copyItem()"
            :disabled="lastPathInOrder === 'Attachments'"
          >
            Move
          </v-btn>
          <v-btn
            class="text-capitalize error--text"
            outline
            @click="copyItemDialogOpened = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="firmUserDialogOpened"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="600"
      persistent
      @keydown.esc="firmUserDialogOpened = false"
    >
      <v-card>
        <v-card-title class="title pb-0">
          Firm Users in Conversation
        </v-card-title>
        <v-card-text v-if="!isEmpty(firmUsers) && selectedConversation">
          <v-alert outline :value="true" type="info" class="mb-4"
            >Users you select will be notified of every new message in this
            conversation.</v-alert
          >
          <v-flex class="text-xs-left ml-2">
            <div>Team Members</div>
            <v-autocomplete
              multiple
              class="default-input body-1"
              hide-details
              solo
              :items="firmUsers"
              v-model="selectedFirmUserIds"
              item-text="name"
              item-value="id"
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  small
                  v-if="selectedFirmUserIds.indexOf(data.item.id) === 0"
                >
                  <span>{{ data.item.name }}</span>
                </v-chip>
                <span
                  v-if="selectedFirmUserIds.indexOf(data.item.id) === 1"
                  class="grey--text caption"
                  >(+{{ selectedFirmUserIds.length - 1 }} other{{
                    selectedFirmUserIds.length > 2 ? 's' : ''
                  }})</span
                >
              </template>
            </v-autocomplete>
          </v-flex>
        </v-card-text>
        <v-card-text v-else>
          <v-progress-circular
            indeterminate
            size="100"
            color="primary"
          ></v-progress-circular>
        </v-card-text>
        <v-card-actions>
          <v-spacer class="hidden-xs-only" />
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            class="default-input primary text-capitalize"
            @click="updateConversation()"
          >
            Save
          </v-btn>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            outline
            class="default-input error--text text-capitalize"
            @click="firmUserDialogOpened = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      width="600"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="scheduledTimeDialogOpened"
      persistent
      @keydown.esc="scheduledTimeDialogOpened = false"
    >
      <v-card flat>
        <v-card-title class="title pb-1"> Schedule message </v-card-title>
        <v-card-title class="subheading pt-0">
          {{ timeZone }}
        </v-card-title>
        <v-card-text class="mb-1 mt-1">
          <date-picker
            v-model="scheduledTime"
            type="datetime"
            :showSecond="false"
            inline
            use12h
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="text-capitalize primary"
            @click="editMessage"
            :disabled="!scheduledTime"
            :loading="sending"
          >
            Schedule Message
          </v-btn>
          <v-btn
            class="text-capitalize primary--text"
            outline
            @click="
              scheduledTimeDialogOpened = false;
              scheduledTime = null;
            "
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <export-conversation-dialog
      v-model="showExportDialog"
      v-if="selectedConversation"
      :conversation-id="selectedConversation.id"
      :selected-users="selectedConversationUsers"
    />

    <v-card-title class="title py-1">
      <v-layout align-center no-wrap class="text-truncate py-0">
        <div class="text-truncate text-xs-left py-2">
          <span v-if="selectedConversation && selectedConversation.name">{{
            selectedConversation.name
          }}</span
          ><span v-else>{{ selectedConversationUsers }}</span>
        </div>
        <v-flex
          class="hidden-xs-only"
          shrink
          v-if="!isEmpty(conversationCompanies) && !conversationPage"
        >
          <v-select
            class="default-input ml-2"
            :items="conversationCompaniesMapped"
            :placeholder="
              conversationCompanies.length +
                ' related entit' +
                (conversationCompanies.length > 1 ? 'ies' : 'y')
            "
            solo
            :value="selectedEntityId"
            hide-details
            item-text="name"
            item-value="id"
            clearable
            @change="changeCompany"
          />
        </v-flex>
        <v-spacer />
        <soraban-action-button
          v-if="currentUser.is_advisor"
          @click="showExportDialog = true"
          icon="get_app"
          help="Export Conversation"
        />
        <soraban-action-button
          v-if="currentUser.is_advisor"
          @click="markAsUnseen()"
          icon="visibility_off"
          help="Mark as unseen"
          shortcut="u"
        />
        <soraban-action-button
          v-else-if="currentUser.is_advisor && hasReminders"
          @click="removeReminder()"
          icon="notifications_off"
          :help="
            `Remove reminder for ${moment(
              this.selectedConversation.reminders.find(
                r => r.user_id === this.currentUser.id,
              ).scheduled_time,
            ).format('lll')}`
          "
        />
        <soraban-action-button
          v-if="currentUser.is_advisor"
          @click="openFirmUserDialog()"
          icon="group"
          help="Manage Firm Users"
        />
        <v-tooltip
          bottom
          class="mx-1 hidden-sm-and-down"
          v-if="!conversationPage"
        >
          <v-btn
            slot="activator"
            fab
            small
            flat
            :class="fullscreenDialog ? 'primary--text' : ''"
            class="white text-capitalize ma-0 ml-1"
            @click="$emit('update:fullscreenDialog', !fullscreenDialog)"
          >
            <v-icon size="25"> fullscreen </v-icon>
          </v-btn>
          <span>Fullscreen</span>
        </v-tooltip>
        <v-btn
          small
          flat
          class="white error--text text-capitalize"
          @click="closeConversationDialog()"
          fab
          :disabled="sending"
          v-if="!conversationPage"
        >
          <v-icon size="24"> clear </v-icon>
        </v-btn>
      </v-layout>
    </v-card-title>

    <v-card-text class="my-0 py-0 px-2 conversation-content-container">
      <v-alert
        v-if="
          selectedConversation &&
            isEmpty(selectedConversation.relevant_company_ids)
        "
        :value="true"
        outline
        block
        :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
        color="error"
        class="text-xs-left mb-2"
      >
        There are no related entities for this conversation. Please use a
        different conversation as messaging is disabled for this conversation.
        {{
          this.currentUser.is_advisor
            ? 'Please message us if you want the message history to be moved to a different conversation'
            : ''
        }}
      </v-alert>
      <v-alert
        v-if="
          selectedConversation && selectedConversation.advisor_out_of_office
        "
        :value="true"
        outline
        block
        :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
        color="primary"
        class="text-xs-left mb-2"
        style="white-space: pre-line"
        >{{ selectedConversation.advisor_out_of_office_message }}
      </v-alert>
      <v-alert
        v-else-if="
          selectedConversation &&
            isAdvisor &&
            !selectedConversation.advisor_ids.includes(this.currentUser.id)
        "
        :value="true"
        outline
        block
        :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
        color="primary"
        class="text-xs-left mb-2"
      >
        You are not in this conversation. Send a message below or add yourself
        in the notifications by clicking the <b>Firm Users</b> button on the
        right.
      </v-alert>
      <v-alert
        v-else-if="
          selectedConversation && isEmpty(selectedConversation.messages)
        "
        :value="true"
        outline
        block
        :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
        color="primary"
        class="text-xs-left mb-2"
      >
        There are no messages in this conversation.
        {{
          selectedConversation.has_test_clients
            ? 'The test client will reply immediately in this conversation.'
            : ''
        }}
      </v-alert>
      <v-divider v-else class="pt-1" />
      <v-layout column v-if="loading || !selectedConversation" align-center>
        <v-progress-circular
          indeterminate
          size="100"
          class="ma-5"
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-layout
        v-else-if="selectedConversation"
        column
        class="messages-container"
        ref="messageContainer"
      >
        <template v-for="(message, i) in selectedConversation.messages">
          <div
            v-if="
              currentUser.is_advisor ||
                (!currentUser.is_advisor && !message.scheduled)
            "
            class="message-line mb-2"
            :class="{ scheduled: !!message.scheduled }"
            :key="`message_${i}`"
          >
            <v-layout
              column
              align-center
              class="darkgrey--text body-1 my-2 text-xs-center"
              v-if="message.is_log"
              v-html="
                '<span>' +
                  moment(message.created_at).format('lll') +
                  ' - ' +
                  message.user_name +
                  ' ' +
                  message.text +
                  '</span>'
              "
            />
            <v-layout
              v-else-if="message.user_id !== currentUser.id"
              align-start
            >
              <v-avatar
                size="30"
                color="#ebebeb"
                class="message-line__avatar hidden-xs-only"
              >
                <v-icon> person </v-icon>
              </v-avatar>
              <v-layout
                column
                align-start
                v-if="message.text.includes('$$attached$$')"
              >
                <v-layout
                  column
                  :class="`message-line__text message-line__text--advisor`"
                >
                  <v-layout
                    align-center
                    v-if="message.unseen_user_ids.includes(currentUser.id)"
                  >
                    <v-divider class="mx-2" />
                    <div
                      class="error--text font-weight-bold"
                      v-if="message.tag === 'emergency'"
                    >
                      EMERGENCY
                    </div>
                    <div
                      class="warning--text font-weight-bold"
                      v-else-if="message.tag === 'urgent'"
                    >
                      URGENT
                    </div>
                    <div class="primary--text font-weight-bold" v-else>New</div>
                    <v-divider class="mx-2" />
                  </v-layout>
                  <!-- <v-chip small class="mr-1" v-if="message.user.is_advisor">Accountant</v-chip> -->
                  <v-layout>
                    <b class="mr-1 mt-1">{{ message.user_name }}</b
                    ><span class="mt-1 mr-1">attached</span>
                    <v-layout column>
                      <v-tooltip
                        bottom
                        v-for="(documentLink, i) in getDocumentLinks(message)"
                        :key="i"
                      >
                        <v-chip
                          small
                          slot="activator"
                          class="clickable-chip"
                          @click="previewDocument(documentLink, message)"
                        >
                          <v-icon size="18">attach_file</v-icon
                          ><span
                            class="text-truncate"
                            :style="
                              $vuetify.breakpoint.smAndUp
                                ? 'max-width: 300px'
                                : 'max-width: 100px'
                            "
                            >{{ getDocumentName(documentLink) }}</span
                          >
                        </v-chip>
                        <span
                          >Click to preview
                          <span
                            >(already saved under 'Attachments' in
                            Documents)</span
                          ></span
                        >
                      </v-tooltip>
                    </v-layout>
                  </v-layout>
                </v-layout>
                <div
                  class="message-line__timestamp ml-1"
                  v-if="
                    !message.scheduled &&
                      (i === selectedConversation.messages.length - 1 ||
                        moment(
                          selectedConversation.messages[i + 1].created_at,
                        ).diff(moment(message.created_at)) > 3600000)
                  "
                >
                  {{ moment(message.created_at).format('lll') }}
                </div>
                <div v-if="message.scheduled" class="message-line__timestamp">
                  <b>Scheduled:</b>
                  {{ moment(message.scheduled_time).format('lll') }}
                </div>
              </v-layout>
              <v-layout column align-start v-else>
                <div :class="`message-line__text message-line__text--advisor`">
                  <v-layout
                    align-center
                    v-if="message.unseen_user_ids.includes(currentUser.id)"
                  >
                    <v-divider class="mx-2" />
                    <div
                      class="error--text font-weight-bold"
                      v-if="message.tag === 'emergency'"
                    >
                      EMERGENCY
                    </div>
                    <div
                      class="warning--text font-weight-bold"
                      v-else-if="message.tag === 'urgent'"
                    >
                      URGENT
                    </div>
                    <div class="primary--text font-weight-bold" v-else>New</div>
                    <v-divider class="mx-2" />
                  </v-layout>
                  <v-tooltip
                    class="mr-1"
                    v-if="message.tag === 'emergency'"
                    bottom
                  >
                    <v-icon slot="activator" class="error--text" size="18"
                      >warning</v-icon
                    >
                    <span>Emergency</span>
                  </v-tooltip>
                  <v-tooltip
                    class="mr-1"
                    v-else-if="message.tag === 'urgent'"
                    bottom
                  >
                    <v-icon slot="activator" class="warning--text" size="18"
                      >error</v-icon
                    >
                    <span>Urgent</span>
                  </v-tooltip>
                  <v-layout align-center
                    ><b class="mr-2 ph-no-capture"
                      >{{ message.user_name }}
                      <v-chip class="team-title" v-if="message.is_firm_user"
                        >{{ currentFirm.name }} Team</v-chip
                      ></b
                    >
                  </v-layout>
                  <span class="preview ql-editor" v-html="message.text" />
                </div>
                <div
                  class="message-line__timestamp ml-1"
                  v-if="
                    !message.scheduled &&
                      (i === selectedConversation.messages.length - 1 ||
                        moment(
                          selectedConversation.messages[i + 1].created_at,
                        ).diff(moment(message.created_at)) > 3600000)
                  "
                >
                  {{ moment(message.created_at).format('lll') }}
                </div>
                <div v-if="message.scheduled" class="message-line__timestamp">
                  <b>Scheduled:</b>
                  {{ moment(message.scheduled_time).format('lll') }}
                </div>
              </v-layout>
            </v-layout>
            <v-layout v-else align-start justify-end>
              <v-layout
                column
                align-end
                v-if="message.text.includes('$$attached$$')"
              >
                <v-layout
                  align-start
                  :class="`message-line__text message-line__text--user`"
                >
                  <b class="mr-1 mt-1">You: </b>
                  <span class="mt-1 mr-1">attached</span>
                  <v-layout column>
                    <v-tooltip
                      bottom
                      v-for="(documentLink, i) in getDocumentLinks(message)"
                      :key="i"
                    >
                      <v-chip
                        small
                        slot="activator"
                        class="clickable-chip"
                        @click="previewDocument(documentLink, message)"
                      >
                        <v-icon size="18">attach_file</v-icon
                        ><span
                          class="text-truncate"
                          :style="
                            $vuetify.breakpoint.smAndUp
                              ? 'max-width: 300px'
                              : 'max-width: 100px'
                          "
                          >{{ getDocumentName(documentLink) }}</span
                        >
                      </v-chip>
                      <span
                        >Click to preview
                        <span
                          >(already saved under 'Attachments' in
                          Documents)</span
                        ></span
                      >
                    </v-tooltip>
                  </v-layout>
                </v-layout>
                <div
                  class="message-line__timestamp message-line__timestamp mr-1"
                  v-if="
                    !message.scheduled &&
                      (i === selectedConversation.messages.length - 1 ||
                        moment(
                          selectedConversation.messages[i + 1].created_at,
                        ).diff(moment(message.created_at)) > 3600000)
                  "
                >
                  {{ moment(message.created_at).format('lll') }}
                </div>
                <div v-if="message.scheduled" class="message-line__timestamp">
                  <b>Scheduled:</b>
                  {{ moment(message.scheduled_time).format('lll') }}
                </div>
              </v-layout>
              <v-layout v-else column align-end justify-end>
                <div :class="`message-line__text message-line__text--user`">
                  <v-tooltip
                    class="mr-1"
                    v-if="message.tag === 'emergency'"
                    bottom
                  >
                    <v-icon slot="activator" class="error--text" size="18"
                      >warning</v-icon
                    >
                    <span>Emergency</span>
                  </v-tooltip>
                  <v-tooltip
                    class="mr-1"
                    v-else-if="message.tag === 'urgent'"
                    bottom
                  >
                    <v-icon slot="activator" class="warning--text" size="18"
                      >error</v-icon
                    >
                    <span>Urgent</span>
                  </v-tooltip>
                  <span>
                    <v-tooltip
                      bottom
                      v-if="
                        message.has_reminder &&
                          i === selectedConversation.messages.length - 1
                      "
                    >
                      <v-icon
                        slot="activator"
                        class="white--text subheading"
                        style="cursor: pointer"
                        @click="removeAutoReminder()"
                        >notifications</v-icon
                      >
                      <span>Remove Auto-Reminder</span>
                    </v-tooltip>
                    <b class="ml-1">You:</b>
                  </span>
                  <span class="preview ql-editor" v-html="message.text" />
                </div>
                <div
                  class="message-line__timestamp message-line__timestamp mr-1"
                  v-if="
                    !message.scheduled &&
                      (i === selectedConversation.messages.length - 1 ||
                        moment(
                          selectedConversation.messages[i + 1].created_at,
                        ).diff(moment(message.created_at)) > 3600000)
                  "
                >
                  {{ moment(message.created_at).format('lll') }}
                </div>
                <div v-if="message.scheduled" class="message-line__timestamp">
                  <b>Scheduled:</b>
                  {{
                    moment(message.scheduled_time)
                      .utc()
                      .local()
                      .format('lll')
                  }}
                </div>
              </v-layout>
            </v-layout>
            <v-layout
              column
              v-if="currentUser.is_advisor && message.scheduled"
              style="max-width: 30px"
            >
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  small
                  fab
                  style="height: 20px; width: 20px"
                  @click.native.stop
                  :loading="cancelingMessage"
                  class="red--text ml-2 my-0 pa-0"
                  flat
                  @click.prevent.stop="cancelScheduledMessage(message.id)"
                >
                  <v-icon size="18">cancel</v-icon>
                </v-btn>
                <span>Cancel message</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  small
                  fab
                  style="height: 20px; width: 20px"
                  @click.native.stop
                  :loading="cancelingMessage"
                  class="primary--text ml-2 my-0 pa-0"
                  flat
                  icon
                  @click.prevent.stop="editScheduledMessage(message)"
                >
                  <v-icon size="18">edit</v-icon>
                </v-btn>
                <span>Edit time</span>
              </v-tooltip>
            </v-layout>
          </div>
        </template>

        <div style="display: none" ref="lastMessage" />
        <template
          v-if="
            currentUser.is_advisor &&
              lastMessageInSelectedConversation &&
              !lastMessageInSelectedConversation.scheduled
          "
        >
          <div
            class="text-xs-right grey--text text--darken-1 mr-1"
            v-if="
              currentUser.is_advisor &&
                lastMessageInSelectedConversation &&
                lastMessageInSelectedConversation.unseen_user_ids.length >= 1 &&
                lastMessageInSelectedConversation.user_id === currentUser.id
            "
          >
            Unseen by
            {{ lastMessageInSelectedConversation.unseen_user_ids.length }}
          </div>
          <div
            class="text-xs-right grey--text text--darken-1 mr-1"
            v-else-if="
              currentUser.is_advisor &&
                lastMessageInSelectedConversation &&
                lastMessageInSelectedConversation.unseen_user_ids.length ===
                  0 &&
                lastMessageInSelectedConversation.user_id === currentUser.id
            "
          >
            Seen by All
          </div>
        </template>
      </v-layout>
      <v-layout
        v-if="
          selectedConversation &&
            isOpen &&
            !isEmpty(selectedConversation.relevant_company_ids)
        "
        style="flex-grow: 0"
        align-center
        class="mr-1 py-3"
      >
        <MessageEditor
          :conversation-companies="conversationCompanies"
          :selected-conversation-id="selectedConversationId"
          @messageSent="updateMessagesBox"
        />
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from 'moment';
import get from 'lodash/get';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import PreviewDocument from '@/components/PreviewDocument';
import MessageEditor from '@/components/MessageEditor';
import ExportConversationDialog from './dialogs/ExportConversationDialog';
import firebase from 'firebase';
import { supportedExtensionsForPreview } from '@/constants/variables';
import heicConvert from 'heic-convert';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'ConversationBox',
  props: {
    selectedConversationId: {
      required: false,
      type: Number,
    },
    currentUser: {
      required: true,
      type: Object,
    },
    hashCompany: {
      required: false,
      type: Object,
    },
    conversationPage: {
      type: Boolean,
      required: false,
    },
    isOpen: {
      type: Boolean,
    },
    fullscreenDialog: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ExportConversationDialog,
    PreviewDocument,
    MessageEditor,
    DatePicker,
  },
  data() {
    return {
      selectedEntityId: null,
      supportedExtensionsForPreview,
      scheduledTimeDialogOpened: false,
      scheduledTime: null,
      cancelingMessage: false,
      showExportDialog: false,
      newName: '',
      previewDialogOpened: false,
      selectedConversation: null,
      loading: false,
      sending: false,
      selectedCompanyId: null,
      documentPreviewData: '',
      previewLoaded: false,
      selectedDocumentName: '',
      previewType: '',
      previewRotation: 0,
      renameFile: false,
      selectedDocumentLink: '',
      copyItemDialogOpened: false,
      pathsInOrder: [],
      foldersInLastPath: [],
      selectedMessageId: null,
      lastPathInOrder: '',
      addLinkDialog: false,
      linkText: '',
      linkURL: '',
      selectedFirmUserIds: [],
      reminderDateRules: [
        v => moment() < moment(v) || !v || 'Due date must be in the future',
      ],
      firmUsers: [],
      firmUserDialogOpened: false,
      reminderSaving: false,
      remindClient: false,
      messageTag: 'general',
      listeningToNewMessages: null,
      newMessagesRef: null,
    };
  },
  computed: {
    ...mapGetters([
      'isAdvisor',
      'savedConversationPageMessage',
      'savedConversationDialogMessage',
      'isFirmDocumentsDisabled',
      'currentFirm',
    ]),
    timeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    lastMessageInSelectedConversation() {
      return this.selectedConversation.messages[
        this.selectedConversation.messages.length - 1
      ];
    },
    ...mapState('companies', ['companies']),
    conversationCompanies() {
      if (
        this.selectedConversation &&
        this.selectedConversation.relevant_company_ids
      ) {
        return this.companies.filter(c =>
          this.selectedConversation.relevant_company_ids.includes(c.id),
        );
      }
    },
    linkAddable() {
      return !isEmpty(this.linkText) && !isEmpty(this.linkURL);
    },
    selectedConversationUsers() {
      if (this.selectedConversation) {
        if (this.isAdvisor) {
          if (!isEmpty(this.selectedConversation.client_names)) {
            return this.selectedConversation.client_names
              .filter(u => u !== this.currentUser.full_name)
              .join(', ');
          } else {
            return this.selectedConversation.advisor_names
              .filter(u => u !== this.currentUser.full_name)
              .join(', ');
          }
        } else {
          return this.selectedConversation.client_names
            .filter(u => u !== this.currentUser.full_name)
            .concat(this.currentFirm.name + ' Team')
            .join(', ');
        }
      }
    },
    hasReminders() {
      if (this.selectedConversation) {
        return !isEmpty(
          this.selectedConversation.reminders.filter(
            r => r.user_id === this.currentUser.id,
          ),
        );
      }
    },
    conversationCompaniesMapped() {
      if (this.conversationCompanies) {
        return this.conversationCompanies.map(c => {
          return {
            id: c.id,
            name: `${c.tax_return_name} (${c.entity_type})`,
          };
        });
      }
    },
  },
  methods: {
    moment,
    get,
    heicConvert,
    changeCompany(id) {
      if (id) {
        this.selectedEntityId = null;
        console.log(id);
        this.$emit('change-company', id);
      }
    },
    async editMessage() {
      this.cancelingMessage = true;
      await API.conversation.editScheduledMessage(
        this.selectedMessageId,
        moment(this.scheduledTime)
          .utc()
          .toISOString(),
      );
      await this.updateMessagesBox();
      this.scheduledTimeDialogOpened = false;
      this.cancelingMessage = false;
    },
    async cancelScheduledMessage(messageId) {
      this.cancelingMessage = true;
      await API.conversation.deleteScheduledMessage(messageId);
      await this.updateMessagesBox();
      this.cancelingMessage = false;
    },
    async editScheduledMessage(message) {
      this.selectedMessageId = message.id;
      this.scheduledTimeDialogOpened = true;
      this.scheduledTime = moment(message.scheduledTime)
        .utc()
        .local()
        .toDate();
    },
    async updateConversation() {
      if (isEmpty(this.selectedFirmUserIds)) {
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'You have to have at least one team member in the conversation.',
        });
        this.firmUserDialogOpened = false;
      } else {
        try {
          const response = await API.conversation.updateConversation({
            id: this.selectedConversation.id,
            advisor_ids: this.selectedFirmUserIds,
          });
          console.log(response.data);
          if (response.data.error) {
            this.$store.dispatch('application/setErrorNotification', {
              message: 'There was a problem saving the conversation.',
            });
            console.log(e);
          } else {
            this.$store.dispatch('application/setSuccessNotification', {
              message: 'Conversation was saved.',
            });
            this.selectedConversation.advisor_ids = this.selectedFirmUserIds;
            this.firmUserDialogOpened = false;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    async removeAutoReminder() {
      try {
        const response = await API.conversation.removeAutoReminder(
          this.selectedConversation.id,
        );
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem removing the auto reminder.',
          });
          console.log(response.data.error);
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: "You've removed the auto reminder.",
          });
          this.selectedConversation = response.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async updateMessagesBox() {
      console.log('message sent');
      await this.refreshConversation();
      this.$vuetify.goTo(this.$refs.messageContainer.scrollHeight + 1000, {
        container: this.$refs.messageContainer,
      });
    },
    addLink() {
      if (this.linkURL.includes('https:')) {
        this.newMessage = this.newMessage += `<a href="${this.linkURL}">${this.linkText}</a>`;
      } else {
        this.newMessage = this.newMessage += `<a href="https://${this.linkURL}">${this.linkText}</a>`;
      }
      this.addLinkDialog = false;
      this.linkURL = '';
      this.linkText = '';
    },
    startRenaming() {
      this.documentExtension = this.getDocumentName(this.selectedDocumentLink)
        .split('.')
        .pop();
      this.newName = this.getDocumentName(this.selectedDocumentLink).replace(
        `.${this.documentExtension}`,
        '',
      );
      this.renameFile = true;
    },
    async markAsUnseen() {
      await API.conversation.markAsUnseen(this.selectedConversationId);
      this.$emit('markAsUnseen', true);
    },
    async downloadDocumentByLink(url, name) {
      const link = document.createElement('a');
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', name);
      link.target = '_blank';
      link.href = url;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    getDocumentName(link) {
      return link.split('/')[link.split('/').length - 1];
    },
    getDocumentLinks(message) {
      return message.text.split('$$')[2].split('&!&');
    },
    endsWithAny(suffixes, string) {
      return suffixes.find(function(suffix) {
        return string.toLowerCase().endsWith(suffix);
      });
    },
    closeConversationDialog() {
      this.remindClient = false;
      this.messageTag = 'general';
      this.$emit('closeConversationDialog', true);
    },
    async previewDocument(documentLink, message) {
      this.selectedMessageId = message.id;
      this.previewLoaded = false;
      try {
        const response = await API.conversation.downloadAttachment(
          documentLink,
        );
        if (response.data.document) {
          this.previewDialogOpened = true;
          console.log(documentLink);
          let company = this.companies.find(
            c => c.name === documentLink.split('/')[2],
          );
          this.selectedCompanyId = !isEmpty(company) ? company.id : null;

          this.selectedDocumentLink = documentLink;
          this.previewType = this.endsWithAny(
            this.supportedExtensionsForPreview,
            this.getDocumentName(documentLink),
          );
          if (this.previewType === 'heic') {
            this.documentPreviewData = await this.convertToJPEG(
              response.data.document.data.link,
            );
          } else {
            this.documentPreviewData = response.data.document.data.link;
          }
        } else {
          console.log(response.data.error);
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem downloading the document.',
            errorToSend: response.data.error,
            userEmail: this.currentUser.email,
          });
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem downloading the document.',
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      } finally {
        this.previewLoaded = true;
      }
    },
    async convertToJPEG(url) {
      const output = await fetch(url).then(async data => {
        const buffer = Buffer.from(await data.arrayBuffer());
        return heicConvert({ buffer, format: 'JPEG' });
      });
      const imgBase64 = btoa(
        output.reduce(
          (data, byte) => `${data}${String.fromCharCode(byte)}`,
          '',
        ),
      );
      return `data:image/png;base64,${imgBase64}`;
    },
    goBackPathForMove(path, index) {
      if (index !== this.pathsInOrder.length - 1) {
        this.pathsInOrder = this.pathsInOrder.slice(0, index + 1);
        this.getFoldersInLastPath();
        this.lastPathInOrder = null;
      }
    },
    changePath() {
      this.pathsInOrder.push(this.lastPathInOrder);
      this.getFoldersInLastPath();
      this.lastPathInOrder = null;
    },
    openCopyDialog() {
      this.pathsInOrder = this.selectedDocumentLink.split('/');
      this.pathsInOrder.shift();
      this.pathsInOrder.pop();
      this.pathsInOrder.pop();
      this.lastPathInOrder = null;
      this.getFoldersInLastPath();
      this.copyItemDialogOpened = true;
    },
    async getFoldersInLastPath() {
      try {
        const response = await API.conversation.getFolders(
          '/'.concat(this.pathsInOrder.join('/')),
        );
        if (response.data.error) {
          console.log(response.data.error);
          this.$store.dispatch('application/setErrorNotification', {
            message: `There was a problem retrieving folders`,
          });
        } else {
          this.foldersInLastPath = response.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async openFirmUserDialog() {
      const response = await API.firm.getAllUsers();
      if (response.data.error) {
        console.log(response.data.error);
      } else {
        this.firmUsers = response.data.users;
        this.selectedFirmUserIds = this.selectedConversation.advisor_ids;
      }
      this.firmUserDialogOpened = true;
    },
    async copyItem() {
      try {
        this.copyItemDialogOpened = false;
        this.copying = true;
        const response1 = await API.conversation.copyItem({
          link: this.selectedDocumentLink,
          newPath: this.pathsInOrder.join('/'),
        });
        this.$store.dispatch('application/setSuccessNotification', {
          message: `You successfully moved the file!`,
        });
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: `There was a problem moving the file.`,
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      } finally {
        this.copying = false;
        this.pathsInOrder = [];
      }
    },
    async renameItem() {
      try {
        this.sending = true;
        const response1 = await API.conversation.renameItem({
          newName: this.newName.concat('.', this.documentExtension),
          messageId: this.selectedMessageId,
          link: this.selectedDocumentLink,
        });
        if (response1.data.error) {
          console.log(response1.data.error);
          this.$store.dispatch('application/setErrorNotification', {
            message: response1.data.error,
          });
        } else {
          this.selectedDocumentLink = response1.data;
          this.$store.dispatch('application/setSuccessNotification', {
            message: `You successfully renamed the document!`,
          });
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem renaming the document.',
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      } finally {
        await this.refreshConversation();
        this.newName = '';
        this.renameFile = false;
        this.documentExtension = '';
        this.sending = false;
      }
    },
    isEmpty,
    async refreshConversation() {
      if (this.selectedConversationId) {
        try {
          const response = await API.conversation.getConversation(
            this.selectedConversationId,
          );
          this.selectedConversation = Object.assign({}, response.data);
          console.log(this.selectedConversation);
        } catch (e) {
          console.log(e);
          this.$emit('closeConversationDialog');
          this.$store.dispatch('application/setErrorNotification', {
            message: 'Not found.',
          });
        } finally {
          this.loading = false;
        }
      } else {
        this.selectedConversation = null;
      }
    },
    subscribeToNewMessages() {
      const database = firebase.database();

      this.newMessagesRef = database.ref(
        `users/${this.currentUser.id}/newMessages`,
      );
      this.listeningToNewMessages = this.newMessagesRef.on(
        'value',
        async () => {
          if (this.currentUser.id) {
            const isBottom =
              this.$refs.messageContainer &&
              this.$refs.messageContainer.scrollHeight -
                this.$refs.messageContainer.scrollTop ===
                this.$refs.messageContainer.clientHeight;

            await this.refreshConversation();

            setTimeout(() => {
              if (this.$refs.messageContainer && isBottom) {
                this.$refs.messageContainer.scrollTop = this.$refs.messageContainer.scrollHeight;
              }
            }, 500);
          }
        },
      );
    },
    unsubscribeToNewMessages() {
      if (this.listeningToNewMessages && this.newMessagesRef) {
        this.newMessagesRef.off('value', this.listeningToNewMessages);
      }
    },
    async reload() {
      if (
        !isEmpty(this.savedConversationPageMessage) ||
        !isEmpty(this.savedConversationDialogMessage)
      ) {
        if (this.conversationPage) {
          this.newMessage = this.savedConversationPageMessage;
          this.$store.dispatch('setSavedConversationPageMessage', '');
        } else {
          this.newMessage = this.savedConversationDialogMessage;
          this.$store.dispatch('setSavedConversationDialogMessage', '');
        }
      }
      this.loading = true;
      this.selectedEntityId = null;
      await this.refreshConversation();
      if (this.$refs.messageContainer) {
        this.$vuetify.goTo(this.$refs.messageContainer.scrollHeight + 1000, {
          container: this.$refs.messageContainer,
        });
      }
    },
  },
  beforeDestroy() {
    if (this.conversationPage) {
      this.$store.dispatch('setSavedConversationPageMessage', this.newMessage);
    } else {
      this.$store.dispatch(
        'setSavedConversationDialogMessage',
        this.newMessage,
      );
    }

    this.unsubscribeToNewMessages();
  },
  watch: {
    selectedConversationId: {
      async handler() {
        this.reload();
      },
    },
    isOpen: {
      async handler() {
        this.reload();
      },
    },
  },
  async created() {
    this.reload();
    this.subscribeToNewMessages();
  },
};
</script>

<style lang="postcss" scoped>
.scheduled .message-line {
  &__text {
    &--user {
      border: 2px solid #ccc;
      background-color: #ccc;
      color: white;
    }
  }
}
.content-container,
.conversation-content-container,
.messages-container {
  display: flex;
  flex-direction: column;
  flex: auto;
  min-height: 0;
}
.conversation-content-container {
  min-height: 300px;
}
.messages-container {
  padding: 15px;
  border-radius: 8px;
  overflow-y: scroll;
}
.message-line {
  &__avatar {
    margin-right: 8px;
    margin-left: 8px;
    align-self: center;
  }
  &__timestamp {
    font-size: 12px;
    color: #a7a7a7;
    &--user {
      color: white;
    }
  }
  &__text {
    min-width: 200px;
    max-width: 600px;
    border: 2px solid #f5f5f5;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 20px;
    padding-left: 20px;
    border-radius: 8px;
    text-align: left;
    background-color: #f5f5f5;
    color: black;
    overflow-wrap: break-word;
    &--user {
      border: 2px solid #527692;
      background-color: #527692;
      color: white;
      >>> a {
        color: white;
      }
    }
  }
  & >>> p {
    margin-bottom: 0;
  }

  & >>> .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 3em;
  }
  & >>> .ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 6em;
  }
  & >>> .ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 9em;
  }
  & >>> .ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 12em;
  }
  & >>> .ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 15em;
  }
  & >>> .ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 18em;
  }
  & >>> .ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 21em;
  }
  & >>> .ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 24em;
  }

  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  margin-top: 10px;
  margin-bottom: 10px;
}
.conversation {
  &__container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding-right: 15px;
    padding-left: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
    cursor: pointer;
  }
  &__date {
    display: flex;
    color: #a7a7a7;
    font-size: 11px;
  }
  &__message {
    display: flex;
    color: #373737;
    font-size: 14px;
    align-items: center;
  }
}
.clickable-chip {
  & >>> .v-chip__content {
    cursor: pointer !important;
  }
}

.team-title {
  & >>> .v-chip__content {
    white-space: pre-wrap;
    max-width: 100%;
    height: auto;
    min-height: 20px;
  }
}
.team-title {
  max-width: 300px;
}
</style>
